import React from "react";
import { useNavigate } from "react-router-dom";

import CampaignSection from "../components/campaign-section";
// import Magazine from "../components/magazine";
import ScrollToTopButton from "../components/scroll-to-top-btn";

import pay1 from "../assets/IMG-20241223-WA0065.jpg";
import pay2 from "../assets/IMG-20241223-WA0066.jpg";
import pay3 from "../assets/IMG-20241223-WA0003.jpg";

import mouth1 from "../assets/265_RAF Posters_A1.jpg";
import mouth2 from "../assets/IMG-20241223-WA0007.jpg";
import mouth3 from "../assets/IMG-20241223-WA0008.jpg";

import myLeightons1 from "../assets/myleightons-1.jpg";
import myLeightons2 from "../assets/myleightons-2.jpg";
import myLeightons3 from "../assets/myleightons-3.jpg";
import myLeightons4 from "../assets/myleightons-4.jpg";
import myLeightons5 from "../assets/myleightons-5.jpg";
import myLeightons6 from "../assets/myleightons-6.jpg";

// import beYou1 from "../assets/B-Y- 1.png";
// import beYou2 from "../assets/B-Y- 2.png";
// import beYou3 from "../assets/B-Y- 3.png";
// import beYou4 from "../assets/Linkedin-ad.jpg";
// import beYou5 from "../assets/ABDO Canteen_Page_2.jpg";
// import beYou6 from "../assets/Image_20250121_085920_501.jpeg";

import hereComes1 from "../assets/14076_Leightons Sunglasses Posters_Bike.jpg";
import hereComes2 from "../assets/14076_Leightons Sunglasses Posters_Car.jpg";
import hereComes3 from "../assets/14076_Leightons Sunglasses Posters_Dog.jpg";
import hereComes4 from "../assets/14076_Leightons Sunglasses Posters_Garden.jpg";
import hereComes5 from "../assets/14076_Leightons Sunglasses Posters_Golf.jpg";
import hereComes6 from "../assets/Summer - See The Road Ahead-padding-01.png";

import myopia1 from "../assets/S11099 Leightons Myopia A1 Poster_Options_Page_1.jpg";
import myopia2 from "../assets/S11099 Leightons Myopia A1 Poster_Options_Page_2.jpg";
import myopia3 from "../assets/S11099 Leightons Myopia A1 Poster_Options_Page_3.jpg";

import magCover from "../assets/DSC_0028.jpg";
import magPage1 from "../assets/IMG-20241223-WA0029.jpg";
import magPage2 from "../assets/IMG-20241223-WA0034.jpg";
import magPage3 from "../assets/IMG-20241223-WA0040.jpg";
// import print1 from "../assets/DSC_0035.jpg";
// import print2 from "../assets/DSC_0040.jpg";
// import print3 from "../assets/20250209_160936.jpg";

// import swag1 from "../assets/DSC_0022.jpg";
// import swagMock1 from "../assets/leightons-swag-01.jpg";

// import swag2 from "../assets/DSC_0016.jpg";
// import swagMock2 from "../assets/leightons-swag-02.jpg";

// import swag3 from "../assets/DSC_0012.jpg";
// import swagMock3 from "../assets/leightons-swag-03.jpg";

// import swag4 from "../assets/DSC_0010.jpg";
// import swagMock4 from "../assets/leightons-swag-04.jpg";



const Leightons: React.FC = () => {
  const navigate = useNavigate();

  const payLaterImages = [pay1, pay2, pay3]
  const wordOfMouthImages = [mouth1, mouth2, mouth3]
  const myLeightonsImages = [myLeightons1, myLeightons2, myLeightons3, myLeightons4, myLeightons5, myLeightons6]
  // const beYouImages = [beYou1, beYou2, beYou3, beYou4, beYou5, beYou6]
  const hereComesImages = [hereComes1, hereComes2, hereComes3, hereComes4, hereComes5, hereComes6]
  const myopiaImages = [myopia1, myopia2, myopia3]

  // const pdfUrl = "/S10866_Leightons LIFE_FullIssue.pdf";

  return (
    <div className="mx-10 md:mx-20 mt-10 mb-24">
      <button className="font-frank text-white text-lg hover:underline" onClick={() => navigate("/")}>← Back to Home</button>
      
      <h1 className="font-euro text-white text-3xl mt-8 mb-3">Leightons</h1>
      <div className="border-t-4 border-orange"></div>
      <p className="text-white font-frankbook text-lg mt-5">In my work as a Marketing and Digital Coordinator with Leightons Opticians and Hearing Care, I was able to craft custom graphic assets for use across printed and digital marketing collateral. Taking ownership of project management across campaigns, I coordinated external suppliers and other team members including CRM, website, and print.</p>

      <div className="bg-gradient-to-b from-brown to-purple p-5 md:mx-14 lg:mx-20 mt-10">
        <h3 className="font-euro text-white text-2xl text-center">Marketing Campaigns</h3>
        <p className="text-white font-frankbook text-lg text-center mt-2">Throughout my time in this role, I successfully coordinated numerous campaigns, overseeing the creation of the associated artwork. Highlights include:</p>
      </div>

      <CampaignSection title="Pay Later" description="Promoting no-interest pay later schemes, enabling many more customers to afford healthcare." images={payLaterImages} />
      
      <CampaignSection title="Word of Mouth" description="A campaign highlighting the power of recommendation, vital for independent businesses." images={wordOfMouthImages} />

      <CampaignSection title="MyLeightons" description="Advertising the MyLeightons membership scheme advantages." images={myLeightonsImages} />

      {/* <CampaignSection title="#BeYou" description="Display advertising, promoting the latest job opportunities, encouraging being yourself as part of the Leightons team." images={beYouImages} /> */}

      <CampaignSection title="Here Comes the Sun" description="This campaign highlighted the benefits of caring for your vision, allowing you to fully enjoy every part of summer." images={hereComesImages} />

      <CampaignSection title="Myopia" description="Informative promotion of Myopia Management strategies and further information on the condition." images={myopiaImages} />


      <div>
        <h2 className="text-white font-euro text-3xl mt-14">Magazines & Brochures</h2>
        <div className="border-t-2 border-orange mt-3"></div>
        <p className="text-white font-frankbook text-lg my-5">One of the most complex assets I worked on was the Leightons Life magazine; a major piece of advertising bringing in new customers and providing valuable information and product details. With my confidence working on document setting within InDesign, I conducted the content layout, designing engaging compositions and supporting imagery and graphics. This presented a range of information and helped push the quarterly marketing goals by providing informative content, recommendations, product information, and the benefits of available services.</p>
      </div>

      <img className="px-5 md:px-16 lg:px-32 mt-5 mb-8" src={magCover} alt="Magazine cover" />
      <div className="grid md:grid-cols-3 gap-4 items-center">
          <img src={magPage1} alt="Campaign Images" className="w-full h-auto object-contain" />
          <img src={magPage2} alt="Campaign Images" className="w-full h-auto object-contain" />
          <img src={magPage3} alt="Campaign Images" className="w-full h-auto object-contain" />
      </div>

      {/* <p className="text-white font-frank text-center text-lg lg:text-xl mb-3">Take a flick through!</p>
      <Magazine pdfUrl={pdfUrl} />

      <div className="grid md:grid-cols-3 gap-3 mt-8">
        <img src={print1} alt="Magazine advert" />
        <img src={print2} alt="Magazine sponsor cover" />
        <img className="object-cover" src={print3} alt="Magazine advert" />
      </div> */}

      {/* <div>
        <h2 className="text-white font-euro text-3xl mt-14">Swag</h2>
        <div className="border-t-2 border-orange mt-3"></div>
        <p className="text-white font-frankbook text-lg my-5">This collection of marketing swag showcases my ability to design memorable, brand-aligned promotional materials that engage and delight audiences.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-3 md:mx-10 lg:mx-28">
        <img src={swag1} alt="Mint tin" />
        <img src={swagMock1} alt="Mint tin mock" />
        <img src={swag2} alt="Suncream" />
        <img src={swagMock2} alt="Suncream mock" />
        <img src={swag3} alt="Frisbee" />
        <img src={swagMock3} alt="Frisbee mock" />
        <img src={swag4} alt="Glow stick" />
        <img src={swagMock4} alt="Glow stick mock" />
      </div> */}

      <ScrollToTopButton />
    </div>
  );
};

export default Leightons;
